import React from 'react';
import { BsInfoCircle } from 'react-icons/bs';

import { useHasStoreProducts } from '@/hooks/useHasStoreProducts';
import { useUser } from '@/hooks/useUser';
import { InventoryType } from '@/interfaces/api/InventoryType';

type NoProductsBannerProps = {
	onGoToProducts: () => void;
	message?: string;
	buttonLabel?: string;
};

const NoProductsBanner: React.FC<NoProductsBannerProps> = ({
	onGoToProducts,
	message = 'You have no products. Please add a product to continue.',
	buttonLabel = 'Go to Products',
}) => {
	const { user, isLoading: userIsLoading } = useUser();
	const { hasProducts, isLoading: isHasProductsLoading } =
		useHasStoreProducts(true);

	if (userIsLoading || isHasProductsLoading) {
		return null;
	}

	if (hasProducts) {
		return null;
	}

	if (user?.inventoryType === InventoryType.SHOPIFY) {
		return null;
	}

	return (
		<div
			role="alert"
			aria-label="No products banner"
			tabIndex={0}
			className="mb-4 w-full rounded-lg bg-amber-100 border border-amber-300 text-amber-900 px-4 py-3 flex items-center gap-2 shadow"
		>
			<BsInfoCircle className="text-yellow-600 text-xl" aria-hidden="true" />
			<span className="font-medium">{message}</span>
			<div className="flex-1 flex justify-end">
				<button
					onClick={onGoToProducts}
					className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-4 py-2 rounded ml-4"
					aria-label={buttonLabel}
				>
					{buttonLabel}
				</button>
			</div>
		</div>
	);
};

export default NoProductsBanner;
